import React from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-gradient-to-b from-[#05050A] to-[#0A0A0F] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-primary/15 rounded-full blur-[150px]"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-primary/10 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-2xl mx-auto text-center">
        {/* Compact Headline */}
        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-black font-archive text-white mb-3 leading-tight">
          A próxima vitória<br />
          <span className="text-green-primary">pode ser sua.</span>
        </h2>

        <p className="text-sm sm:text-base text-gray-400 mb-8 max-w-md mx-auto">
          Entre agora. Cada partida é uma chance de se destacar.
        </p>

        {/* CTA Buttons - Stack on mobile */}
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center sm:gap-4 mb-8">
          <Button
            asChild
            data-testid="final-cta-download"
            className="btn-neon w-full sm:w-auto px-8 py-6 text-base sm:text-lg rounded-xl"
          >
            <a 
              href="https://play.google.com/store/games?hl=pt_BR" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Download className="mr-2 h-5 w-5" />
              Baixar Grátis
            </a>
          </Button>

          <Button
            asChild
            data-testid="final-cta-playstore"
            variant="outline"
            className="w-full sm:w-auto px-8 py-6 text-base sm:text-lg rounded-xl border-purple-primary/50 text-white hover:bg-purple-primary/20"
          >
            <a 
              href="https://play.google.com/store/games?hl=pt_BR" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
              </svg>
              Play Store
            </a>
          </Button>
        </div>

        {/* Trust badges - horizontal scroll on mobile */}
        <div className="flex items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-gray-500 flex-wrap mt-6">
          <span className="flex items-center gap-1.5">
            <div className="w-2 h-2 bg-green-primary rounded-full"></div>
            Grátis
          </span>
          <span className="flex items-center gap-1.5">
            <div className="w-2 h-2 bg-purple-primary rounded-full"></div>
            Seguro
          </span>
          <span className="flex items-center gap-1.5">
            <div className="w-2 h-2 bg-green-primary rounded-full"></div>
            Sem anúncios
          </span>
        </div>
      </div>
    </section>
  );
};
